import React from 'react';
import type { QuickAddItem, QuickAddCombo } from '../../types';
import StarIcon from '../icons/StarIcon';
import ZapIcon from '../icons/ZapIcon';

interface QuickAddBarProps {
  items: (QuickAddItem | QuickAddCombo)[];
  onAdd: (combo: QuickAddItem | QuickAddCombo) => void;
}

const QuickAddBar: React.FC<QuickAddBarProps> = ({ items, onAdd }) => {
  // Filter out invalid items
  const validItems = items.filter(item => item && item.name);
  
  if (validItems.length === 0) {
    return null; // Don't render if no valid items
  }
  
  return (
    <div className="flex-shrink-0 bg-gradient-to-r from-pink-50 to-rose-50 p-2 sm:p-2.5 md:p-3 border-b border-pink-200 shadow-sm">
      <h3 className="text-[10px] sm:text-xs font-bold text-pink-700 uppercase tracking-wider mb-1 sm:mb-2">⭐ Quick Add Combos</h3>
      <div className="flex gap-1.5 sm:gap-2 overflow-x-auto pb-1">
        {validItems.map(item => {
          const Icon = item.iconType === 'star' ? StarIcon : ZapIcon;
          
          return (
            <button
              key={item.id}
              onClick={() => onAdd(item)}
              className="flex-shrink-0 flex flex-col items-center gap-0.5 sm:gap-1 bg-white border-2 border-pink-300 text-pink-700 font-bold py-1.5 sm:py-2 px-2 sm:px-3 rounded-lg hover:bg-pink-100 hover:scale-105 transition-all duration-200 shadow-sm hover:shadow-md text-[10px] sm:text-xs md:text-sm"
            >
              <div className="flex items-center gap-0.5 sm:gap-1">
                <Icon className="w-3 h-3 sm:w-4 sm:h-4" />
                <span className="whitespace-nowrap">{item.name}</span>
              </div>
              {item.price && item.price > 0 && (
                <span className="text-[9px] sm:text-[10px] md:text-xs font-semibold text-green-600">${item.price.toFixed(2)}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickAddBar;
